export default __webpack_public_path__ + "static/catchup-image-mobile-3d81789a07ac99a653f904d889bb7125.svg";